/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useServiceContext } from '../../../../root'
import { RcmTableDataWrapper } from '../../../rcm-table/RcmTableDataWrapper'
import { ReportsTable } from './ReportsTable'
import useDocumentsListService from '../../../../hooks/useDocumentsListService'

export const ReportsSection: React.FC = () => {
  const { loadReports } = useDocumentsListService()
  const {
    service: {
      filter: { translate }
    }
  } = useServiceContext()

  const loadDataReports = () => {
    const queryParams = {
      pageSize: 5,
      pageStart: 0,
      sortBy: 'updatedAt',
      sortDesc: true
    }
    return loadReports(queryParams, { showObsoleted: false })
  }

  return (
    <>
      <h2 className="reports">{translate('REPORTS_TITLE')}</h2>
      <RcmTableDataWrapper persistenceKey={'dashboardReports'} loadData={loadDataReports}>
        <ReportsTable />
      </RcmTableDataWrapper>
    </>
  )
}
